
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hairstraightener/privacy-policy",
      function () {
        return require("private-next-pages/hairstraightener/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hairstraightener/privacy-policy"])
      });
    }
  